import { FormikProps, FormikValues } from 'formik';
import { useRef } from 'react';

export type FormRef = React.RefObject<FormikProps<FormikValues>>;

/**
 * useForm returns a ref object and multiple handy functions, that can be used to
 * trigger form functionality such as submit or reset from outside the `<Form />` component.
 *
 * Usage: Pass `formRef` to the `<Form />` component and call `handleSubmit` on click of a button.
 */

export interface FormHandle {
  formRef: FormRef;
  handleSubmit: () => void;
  handleReset: () => void;
}

export const useForm = (): FormHandle => {
  const formRef = useRef<FormikProps<FormikValues>>(null);
  const handleSubmit = () => formRef.current?.handleSubmit();
  const handleReset = () => formRef.current?.handleReset();

  return {
    formRef,
    handleSubmit,
    handleReset
  };
};
